export enum PromptAssinatura {
    NaoAssinar,
    PerguntarAntesDeAssinar,
    AssinarAutomaticamente
}
